<div class="dropdown" [style.width]="width" [class.dropdown--open]="isOpen" [class.dropdown--dropUp]="openUp" [class.dropdown--disabled]="disabled" >
  @if (label && label.length > 0) {
  <span class="dropdown__label" >
    {{ label | translate }}
    @if (isRequired && !hideRequiredSign) {
    <span class="color--red">*</span>
    }
  </span>
  }

  <button #containerBtn #container="cdkOverlayOrigin" cdkOverlayOrigin type="button" class="dropdown__toggle" (click)="toggle()" (keydown)="onKeydown($event)" [value]="value" [attr.aria-expanded]="isOpen" >
  
    <span>{{ (selected?.label | translate) || placeholder }}</span>
    <span class="dropdown__arrow" [class.dropdown__arrow--up]="isOpen"></span>
  </button>

  <ng-template
    cdkConnectedOverlay
    [cdkConnectedOverlayOpen]="isOpen"
    [cdkConnectedOverlayOrigin]="container"
    [cdkConnectedOverlayPositions]="dropdownPositions"
    [cdkConnectedOverlayHasBackdrop]="false"
    [cdkConnectedOverlayWidth]="menuWidth || null"
    [cdkConnectedOverlayPanelClass]="'dropdown__overlay-panel'"
    (overlayOutsideClick)="close()"
    (positionChange)="onOverlayPositionChange($event)">
    <ul class="dropdown__menu">
      <li class="dropdown__item" [class.dropdown__item--active]="i === activeIndex" *ngFor="let opt of options; let i = index" (mousedown)="onOptionMouseDown($event)" (click)="select(opt)">
        {{ opt.label | translate }}
      </li>
    </ul>
  </ng-template>
</div>
